var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHidePassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00138 11.0196L5.00138 11.0197L5.00138 11.0197C5.00652 11.0755 5.02197 11.1311 5.04772 11.1818C5.42811 11.9506 5.92593 12.6548 6.51891 13.2734L4.96094 15.6104L5.70978 16.1096L7.18424 13.8979C7.82862 14.442 8.5568 14.8968 9.34782 15.2426L8.08776 18.1827L8.91499 18.5372L10.1904 15.5614C10.9376 15.8021 11.7296 15.9493 12.5514 15.9887V18.86H13.4514V15.9886C14.2723 15.9489 15.0644 15.8014 15.812 15.5604L17.0878 18.5372L17.915 18.1827L16.6545 15.2415C17.4454 14.8958 18.1741 14.4413 18.819 13.8976L20.2936 16.1096L21.0425 15.6104L19.4847 13.2737C20.0788 12.6551 20.5775 11.9508 20.958 11.1818C20.9751 11.1466 20.9871 11.1092 20.9939 11.0708C20.9976 11.0496 20.9998 11.0281 21.0004 11.0066L21.0006 10.9946V10.9945H20.0613C18.7572 13.449 16.0927 15.1442 13.0004 15.1442C9.90272 15.1442 7.24847 13.449 5.94442 10.9945L5.00138 11.0196Z",
    fill: "#807E8D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide-password.d17cd642.svg";
export { ForwardRef as ReactComponent };